import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTattooTextGeneratorConfig } from '@/data/landingConfig/landingTattooTextGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TattooTextGenerator } from './schemaObject';

interface Props {}
const TattooTextGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TattooTextGenerator} />
			<LandingTemplate
				data={landingTattooTextGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTattooGenerator()}
			/>
		</>
	);
};

export default TattooTextGenerator;
